export const STORE_DATA = 'STORE_DATA';